import React from 'react';
import { Table, Popover } from 'antd';
import useGuestHook from './hooks/Guest.hook';
import guestStyles from './Guest.styles';
import { showInfo } from '../../../InfoPMS/InfoPMS';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useSupportedFields } from 'Components/Dashboard/CheckIn/GuestTable/useSupportedFields';

export default function ResponseTable({ data, translate, isDynamicForm, isHybridForm }) {
  const variableName = translate('validation.guest.response.variableName');
  const civitfunData = translate('validation.guest.response.civitfunData');
  const pmsData = translate('validation.guest.response.pmsData');
  const { snakeToCamel, snakeToCapitalizedWithSpace } = useGuestHook();
  const { pmsModuleName } = useSupportedFields();

  const columns = [
    {
      title: variableName,
      dataIndex: 'key',
      key: 'key',
      render: (text, field) => {
        const showInfoIcon = showInfo(pmsModuleName, field.key);
        const infoKey = `fieldInfoByPMS.${pmsModuleName}.${field.key}`;
        const infoText = translate(infoKey) === infoKey ? translate(field.key) : translate(infoKey);

        let displayKey = text;
        if (isDynamicForm || isHybridForm) {
          if (field.key === 'nationality') {
            displayKey = 'document_country';
          } else if (field.key === 'guest_nationality') {
            displayKey = 'nationality';
          }
        }

        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={guestStyles.keyColumn}>
              {snakeToCapitalizedWithSpace(snakeToCamel(displayKey))}
            </div>
            {showInfoIcon && (
              <Popover content={infoText} trigger="hover">
                <InfoCircleOutlined style={{ paddingLeft: 8, fontSize: 14 }} />
              </Popover>
            )}
          </div>
        );
      },
    },
    {
      title: civitfunData,
      dataIndex: 'civitfunData',
      key: 'civitfunData',
      render: (text, record) => (
        <div style={record.isDifferent ? guestStyles.valueColumnDiferent : guestStyles.valueColumn}>
          {text}
        </div>
      ),
    },
    {
      title: pmsData,
      dataIndex: 'pmsData',
      key: 'pmsData',
      render: (text, record) => (
        <div style={record.isDifferent ? guestStyles.valueColumnDiferent : guestStyles.valueColumn}>
          {text}
        </div>
      ),
    },
  ];

  const dataSource = data.mockGuests[0].fields.map((field, index) => {
    const differences = data.differences[0]?.differences;
    const arrDiferences = differences ? Object.keys(differences) : [];
    const arrDiferencesSnakeCase = arrDiferences.map(difference => snakeToCamel(difference));
    const isDifferent = arrDiferencesSnakeCase.includes(snakeToCamel(field.key));

    return {
      key: field.key,
      civitfunData: isDifferent ? differences[snakeToCamel(field.key)].mockedGuest : field.value,
      pmsData: isDifferent ? differences[snakeToCamel(field.key)].pmsGuest : field.value,
      isDifferent: isDifferent,
    };
  });

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      style={isDynamicForm ? guestStyles.tableDynamic : guestStyles.table}
    />
  );
}
